//@flow
import React from 'react';

import {makeStyles, TableCell} from '@material-ui/core';
import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';
import {useProductVariantContext} from '../../../context/productVariant';
import {useProductContext} from '../../../context';
import {useProductVariantActions} from '../../../../products/utils/hooks';
import InlineLoader from '../../../../../elements/LoadingSpinner/InlineLoader';
import {debounce} from '../../../../../utils/functions';
import {useProductVariantRequestContext} from '../../../context/productVariantRequest';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '.5rem',
    position: 'relative',
  },
  numberField: {
    width: '96px',
  },
  loader: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
  },
}));

export default function VariantStockCell() {
  const classes = useStyles();

  const variant = useProductVariantContext();
  const {loading} = useProductVariantActions();
  const variantRequest = useProductVariantRequestContext();

  const [product] = useProductContext(product => {
    return {
      stockEnabled: !!product.stockSetting && product.stockSetting.enabled,
      id: product.id,
    };
  }, false);

  if (!variant || !product.id) return null;

  const handleStockChange = debounce((value: number) => {
    // setVariantStock(product.id, variant.id, value);
    variantRequest.setStock(variant.id, value);
  }, 750);

  return (
    <TableCell component="th" scope="row">
      <div className={classes.container}>
        {loading && (
          <div className={classes.loader}>
            <InlineLoader loading />
          </div>
        )}
        <CustomTextField
          name="stock"
          className={classes.numberField}
          defaultValue={variant.stock}
          type="number"
          disabled={!product.stockEnabled || loading}
          onChange={e => {
            const value = parseInt(e.target.value);
            if (isNaN(value)) return;
            handleStockChange(value);
          }}
        />
      </div>
    </TableCell>
  );
}
